let leads = [
  {
    id: "1",
    clientName: "ЖК Ривьера",
    address: "Батуми",
    status: "measuring",
  },
  {
    id: "2",
    clientName: "Вилла Лазурная",
    address: "Сарпи",
    status: "pricing",
  },
  {
    id: "3",
    clientName: "Офис Техно",
    address: "Батуми",
    status: "new",
  },
];

export const api = {
  getLeads() {
    return Promise.resolve([...leads]);
  },
  updateStatus(id, status) {
    leads = leads.map((l) => (l.id === id ? { ...l, status } : l));
    return Promise.resolve();
  },
};
